import { AsyncPipe, DatePipe } from '@angular/common';
import { Component, input } from '@angular/core';
import { getUaDevice } from '@context/frontend/native/platform';
import { Chemical } from '@context/shared/types/chemical';
import { TranslocoModule } from '@jsverse/transloco';
import { TuiIcon, TuiSizeL, TuiSizeS } from '@taiga-ui/core';
import { ChemicalLatestRevisionPipe } from '../../pipes';
import { ChemicalThumbnailComponent } from '../chemical-thumbnail/chemical-thumbnail.component';
import { IsExpiredPipe } from '@context/frontend/common';

@Component({
	imports: [
		TranslocoModule,
		TuiIcon,
		ChemicalThumbnailComponent,
		ChemicalLatestRevisionPipe,
		IsExpiredPipe,
		AsyncPipe,
		DatePipe,
	],
	selector: 'ctx-chemical-row',
	templateUrl: 'chemical-row.component.html',
	styleUrl: 'chemical-row.component.scss',
	host: {
		'[attr.device]': 'device',
		'[attr.as-table-row]': 'asTableRow()',
		'[attr.size]': 'size()',
	},
})
export class ChemicalRowComponent {
	readonly device = getUaDevice();

	readonly chemical = input.required<Chemical>();

	readonly interactable = input(true);

	readonly asTableRow = input(true);

	readonly showRevision = input(true);

	readonly size = input<TuiSizeL | TuiSizeS>('l');
}
